import ProxyBase from '../../../../../core/proxies/ProxyBase'

class Proxy extends ProxyBase {
  getPortfolioByOrgId(params) {
    return this.get('Portfolio/AllHasOrNotOrganizationId', params)
  }

  addNewCompany(params) {
    return this.post('Library/AddNewCompany', params)
  }

  deleteCompany(params) {
    return this.delete('Library/DeleteCompany', params)
  }

  postCreatePortfolio(params) {
    return this.post('Portfolio/AddNewPortfolio', params)
  }
}

export default new Proxy()
